/** Starter stub — EMS fee installment helpers (platform template). */

function toYmd(value) {
  if (!value) return null;
  const s = String(value).trim();
  if (!s) return null;
  // Prefer YYYY-MM-DD prefix from datetime-local / date inputs
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) return m[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function getInstallmentDueDateOrderError() {
  return null;
}

export function getStandaloneFeeInstallmentDueDateError() {
  return null;
}

/**
 * Min due date for a row in the admissions installment table:
 * day after the previous row's due date (if any).
 */
export function getMinDueDateForInstallmentRow(rows, rowIndex) {
  const list = Array.isArray(rows) ? rows : [];
  const idx = Number(rowIndex);
  if (!Number.isFinite(idx) || idx <= 0) return undefined;

  const prev = toYmd(list[idx - 1]?.due_date);
  if (!prev) return undefined;

  const d = new Date(`${prev}T00:00:00`);
  if (Number.isNaN(d.getTime())) return undefined;
  d.setDate(d.getDate() + 1);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/**
 * Min due date for standalone fee-installment form:
 * day after the previous installment number's due date.
 */
export function getMinDueDateForStandaloneInstallment({
  installmentNumber,
  existingInstallments = [],
  excludeInstallmentId,
} = {}) {
  const num = Number(installmentNumber);
  if (!Number.isFinite(num) || num <= 1) return undefined;

  const list = Array.isArray(existingInstallments) ? existingInstallments : [];
  const prev = list
    .filter((row) => {
      const id =
        row?.organization_ems_fee_installment_id ??
        row?.id ??
        null;
      if (
        excludeInstallmentId != null &&
        id != null &&
        String(id) === String(excludeInstallmentId)
      ) {
        return false;
      }
      return Number(row?.installment_number) === num - 1;
    })
    .map((row) => toYmd(row?.due_date))
    .filter(Boolean)
    .sort()
    .pop();

  if (!prev) return undefined;

  const d = new Date(`${prev}T00:00:00`);
  if (Number.isNaN(d.getTime())) return undefined;
  d.setDate(d.getDate() + 1);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
